import React from 'react';
import { MapPin, MessageCircle, Mail, Clock, Instagram, Star, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
const INSTAGRAM_URL = 'https://instagram.com/dentico_clinic';
const LEAVE_REVIEW_URL = 'https://g.page/r/CUmhstMLWUqlEBM/review';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-178">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-179" />
    </svg>;
}
export function Footer() {
  const {
    t,
    lang
  } = useTranslation();
  const leaveReviewText = lang === 'en' ? 'Leave a Review' : lang === 'ua' ? 'Залишити відгук' : lang === 'ro' ? 'Lăsați o recenzie' : 'Оставить отзыв';
  return <footer className="bg-forest-600 text-ivory/70 py-14 border-t border-white/10" data-id="element-180">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        {/* Brand wordmark */}
        <div className="mb-12" data-id="element-182">
          <Link to={`/${lang}`} className="inline-flex flex-col leading-none" data-id="element-183">
            <span className="text-2xl font-semibold tracking-[0.22em] text-white" style={{
            fontFamily: '"Playfair Display", Georgia, serif'
          }} data-id="element-184">
              DENTICO
            </span>
            <span className="block text-right text-[10px] tracking-[0.4em] text-white uppercase mt-1" data-id="element-185">
              Clinic
            </span>
          </Link>
          <p className="text-sm text-ivory/60 mt-4 max-w-xs" data-id="element-186">
            {lang === 'en' ? 'Private dental clinic in Angel, Islington, London.' : lang === 'ua' ? 'Приватна стоматологічна клініка в Angel, Islington, Лондон.' : lang === 'ro' ? 'Clinică dentară privată în Angel, Islington, Londra.' : 'Частная стоматологическая клиника в Angel, Islington, Лондон.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-187">
          {/* Location */}
          <div className="space-y-4" data-id="element-188">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-189">
              {t('footer.location')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-190">
              <MapPin className="w-5 h-5 text-beige mt-0.5 shrink-0" strokeWidth={1.75} data-id="element-191" />
              <div data-id="element-192">
                <a href="https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-193">
                  <p className="text-ivory/80" data-id="element-194">{t('footer.address')}</p>
                  <p className="text-ivory/60" data-id="element-195">Angel, Islington</p>
                </a>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4" data-id="element-196">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-197">
              {t('footer.contact')}
            </h3>
            <div className="space-y-3" data-id="element-198">
              <a href="tel:+447345197820" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-199">
                <Phone className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-200" />
                <span data-id="element-201">07345 197820</span>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-202">
                <MessageCircle className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-203" />
                <span data-id="element-204">{t('footer.whatsappChat')}</span>
              </a>
              <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-205">
                <TelegramIcon className="w-5 h-5 text-beige" data-id="element-206" />
                <span data-id="element-207">Telegram</span>
              </a>
              <a href="mailto:info@denticoclinic.co.uk" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-208">
                <Mail className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-209" />
                <span data-id="element-210">info@denticoclinic.co.uk</span>
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-211">
                <Instagram className="w-5 h-5 text-beige" strokeWidth={1.75} data-id="element-212" />
                <span data-id="element-213">@dentico_clinic</span>
              </a>
              <a href={LEAVE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors text-beige" data-id="element-214">
                <Star className="w-5 h-5" strokeWidth={1.75} data-id="element-215" />
                <span data-id="element-216">{t('reviews.leaveReview')}</span>
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="space-y-4" data-id="element-217">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-218">
              {t('footer.hours')}
            </h3>
            <div className="flex items-start gap-3" data-id="element-219">
              <Clock className="w-5 h-5 text-beige mt-0.5 shrink-0" strokeWidth={1.75} data-id="element-220" />
              <div className="space-y-2 text-sm w-full" data-id="element-221">
                <div className="flex justify-between gap-4" data-id="element-222">
                  <span className="text-ivory/60" data-id="element-223">{t('footer.monFri')}</span>
                  <span className="text-white" data-id="element-224">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-225">
                  <span className="text-ivory/60" data-id="element-226">{t('footer.saturday')}</span>
                  <span className="text-white" data-id="element-227">10:00 - 18:00</span>
                </div>
                <div className="flex justify-between gap-4" data-id="element-228">
                  <span className="text-ivory/60" data-id="element-229">{t('footer.sunday')}</span>
                  <span className="text-white" data-id="element-230">{t('footer.closed')}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4" data-id="element-231">
            <h3 className="text-base font-semibold text-white mb-4" data-id="element-232">
              {t('footer.legal.title')}
            </h3>
            <div className="flex flex-col space-y-2" data-id="element-233">
              <Link to={`/${lang}/privacy-policy`} className="hover:text-white transition-colors" data-id="element-234">
                {t('footer.legal.privacyPolicy')}
              </Link>
              <Link to={`/${lang}/cookie-policy`} className="hover:text-white transition-colors" data-id="element-235">
                {t('footer.legal.cookiePolicy')}
              </Link>
              <Link to={`/${lang}/patient-privacy-notice`} className="hover:text-white transition-colors" data-id="element-236">
                {t('footer.legal.patientPrivacy')}
              </Link>
              <Link to={`/${lang}/terms-and-conditions`} className="hover:text-white focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ivory/60 rounded-sm transition-colors" data-id="element-237">
                {t('footer.legal.terms')}
              </Link>
            </div>
          </div>
        </div>

        {/* Compact Contact Line */}
        <div className="border-t border-white/10 mt-12 pt-6" data-id="element-238">
          <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-sm text-ivory/60" data-id="element-239">
            <a href="https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-240">
              360–364 City Rd, London EC1V 2PY
            </a>
            <span className="text-ivory/30" data-id="element-241">·</span>
            <a href="tel:+447345197820" className="hover:text-white transition-colors" data-id="element-242">
              07345 197820
            </a>
            <span className="text-ivory/30" data-id="element-243">·</span>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-244">
              WhatsApp
            </a>
            <span className="text-ivory/30" data-id="element-245">·</span>
            <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-246">
              Telegram
            </a>
            <span className="text-ivory/30" data-id="element-247">·</span>
            <a href="mailto:info@denticoclinic.co.uk" className="hover:text-white transition-colors" data-id="element-248">
              Email
            </a>
            <span className="text-ivory/30" data-id="element-249">·</span>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-250">
              Instagram
            </a>
            <span className="text-ivory/30" data-id="element-251">·</span>
            <a href={LEAVE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors text-beige" data-id="element-252">
              {leaveReviewText}
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 text-center text-sm text-ivory/40" data-id="element-253">
          <p data-id="element-254">
            &copy; {new Date().getFullYear()} Dentico Clinic.{' '}
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}